import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProductsPmsHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/products-pms-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip'>
                        {t('Built for Hotels, Designed for Efficiency')}
                    </div>
                    <h1>{t('Supercharge Revenue with Best-in-Class Property Management System & PMS Systems for Hotels')}</h1>
                    <p className='body-large'>
                        {t('Cutting-edge Property Management System that transforms operations for boutique hotels and large-scale resorts alike, empowering teams to delight guests and boost revenue with a high-performing PMS for hotels.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/pmsheader.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default ProductsPmsHeader;
